import React, { useState, useEffect, useMemo, useCallback, useRef } from 'react';
import first from 'lodash/first';
import VisibilitySensor from 'react-visibility-sensor';
import { Loader } from '@els/els-react--loader';
import { Card } from '@els/els-react--card';
import { parseSchemeString } from '@Pages/RetroSynthesis/MultiStepReactionDialog/utils';
import { routeLayoutGetMaxDepth, routeLayoutNest } from '@Pages/RetroSynthesis/ProjectRoutes/components/RsProjectRouteHelper';
import {
  rateLimitedFetchMultiStepReactionPreview,
  clearRateLimitedMultiStepReactionPreviewQueue,
} from '@Pages/RetroSynthesis/MultiStepReactionDialog/MultiStepReactionService';
import RouteThumbnailsTree from '@Pages/RetroSynthesis/RouteTree/components/RouteThumbnailsTree';

function MultiStepPreview({ detail, databaseId }) {
  const [response, setResponse] = useState(null);
  const isRequestedRef = useRef(false);
  const isClosedRef = useRef(false);

  const visibilitySensorOnChange = useCallback(
    (isVisible) => {
      if (isVisible && !isRequestedRef.current) {
        const { rootReactionId, stepReactionIds } = parseSchemeString(detail?.scheme);
        rateLimitedFetchMultiStepReactionPreview({ databaseId, rootReactionId, stepReactionIds })
          .then((resp) => {
            if (!isClosedRef.current) {
              setResponse(resp);
            }
          })
          .catch((error) => {
            Logger.error('Error fetching multi-step reaction preview:', error);
          });
        isRequestedRef.current = true;
      }
    },
    [databaseId, detail?.scheme]
  );

  useEffect(
    () => () => {
      isClosedRef.current = true;
      clearRateLimitedMultiStepReactionPreviewQueue();
    },
    []
  );

  const routeTree = useMemo(() => response && first(routeLayoutNest(response?.routeLayout)), [response]);

  return (
    <>
      <VisibilitySensor onChange={visibilitySensorOnChange} partialVisibility />
      <Card borderWeight="medium" fill>
        <div className="o-els-flex-layout o-els-flex-layout--column o-els-flex-layout--middle">
          <div className="o-els-flex-layout__item u-els-margin-bottom">Multi-step {detail?.stepsCount} steps</div>
          {response ? (
            <div
              className="u-els-display-flex__item"
              style={{
                width: `${routeLayoutGetMaxDepth(routeTree, 1) * 1.25 + 2}rem`,
                height: `${routeLayoutGetMaxDepth(routeTree, 1) * 0.75 + 2}rem`,
              }}>
              <RouteThumbnailsTree tree={routeTree} allowTruncation={false} focusableNodes={false} />
            </div>
          ) : (
            <Loader isVisible isBlocking={false} className="u-els-display-flex__item u-els-width-1o1 u-els-padding" />
          )}
        </div>
      </Card>
    </>
  );
}

export default MultiStepPreview;
